module.exports = __webpack_public_path__ + "img/save_filled_32.fe970380.svg";